<template>
  <div class="tooltipDoc">
    <tooltip text="Tooltip button">
      <span slot="content" class="btn-plus">
        <i class="adx-ic_plus" ></i>
      </span>
    </tooltip>
    <div class="space"></div>
    <tooltip text="Tooltip button">
      <span slot="content" class="btn-plus">
        <i class="adx-ic_more"></i>
      </span>
    </tooltip>
    <div class="space"></div>
    <adx-hover-icon icon="icon-eye" :isDisabled="true" text="tooltip text"/>
    <adx-hover-icon icon="icon-edit" :isDisabled="false" text="tooltip text"/>
    <adx-hover-icon icon="icon-file-copy " text="tooltip text" @selectedIcon="selectedIcon"/>
  </div>
</template>

<script>
import tooltip from '@/components/Tooltip'
import HoverIcon from '@/components/IconHover'
import { type } from 'os';

export default {
  name: "adx-tooltip-doc",
  components: {
    "tooltip": tooltip,
    'adx-hover-icon': HoverIcon
  },
  methods:{
    selectedIcon(){
        this.$router.push({name: 'home'})
    }
  }
}

</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
